import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import CommonHeadingNBtns from "../../common-components/CommonHeadingNBtns";
import { validationHygieneTaskFrequencyForm } from "../hygiene-common/validation";
import {
  add_hygiene_task_freq,
  update_hygiene_task_freq,
} from "../../../data/ApiEndpoints";
import SelectDropdownLabel from "../../components-react/SelectDropdownLabel";
import {
  daysOfWeek,
  generateNumberObjects,
  hygine_task_frequency_categories,
  months,
} from "../../common-data/DropdowData";
import { currentDateOfTheMonth } from "../../common-data/Converts";

const TaskFrequencyForm = ({
  userInfoData,
  callFunction,
  isEdit,
  rowData,
  closeModal,
}) => {
  const dispatch = useDispatch();
  const { postPutLoading } = useSelector((state) => state.common);

  const forminitials = {
    selectedTaskFrequencyName: "",
    frequencyDays: [],
    frequencyDate: "",
    selectedFrequencyInterval: "",
    selectedMonth: "",
    startTime: "",
    endTime: "",
    isActive: isEdit && rowData?.status === "active" ? true : false,
  };
  const [formValues, setFormValues] = useState(forminitials);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const onChangeInput = (e) => {
    setIsSubmit(false);

    const { name, value, type, checked } = e.target;

    setFormValues((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const onChangeDropdown = (value, name) => {
    setIsSubmit(false);

    setFormValues({ ...formValues, [name]: value });
  };

  const handleCheckboxChange = (dayValue) => {
    setIsSubmit(false);

    setFormValues((prev) => {
      const isDaySelected = prev.frequencyDays.includes(dayValue);
      return {
        ...prev,
        frequencyDays: isDaySelected
          ? prev.frequencyDays.filter((d) => d !== dayValue)
          : [...prev.frequencyDays, dayValue],
      };
    });
  };

  const onSubmit = () => {
    setFormErrors(validationHygieneTaskFrequencyForm(formValues));
    setIsSubmit(true);
  };

  const handleAdd = async (payload) => {
    const method = isEdit ? "PUT" : "POST";
    const endpoint = isEdit ? update_hygiene_task_freq : add_hygiene_task_freq;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        setIsSubmit(false);
        closeModal();
        callFunction();
        toast.success(result?.payload?.message || "Success!");
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const userData = {
        name: formValues.statusName,
        color_hex: formValues.statusColor,
        add_gym_req: formValues.isAutoAddToGymReqForm ? 1 : 0,
        status: formValues.isActive ? "active" : "inactive",
      };

      if (isEdit) {
        userData.uid = rowData.uid;
      }

      const handleConfirm = async () => {
        handleAdd(userData);
      };

      showConfirmAlert(
        handleConfirm,
        `Check Before Submit.!`,
        "Edit Form",
        `${isEdit ? "Update" : "Add"} Status`
      );
    }
  }, [isSubmit, formErrors]);

  // console.log("formValues=> ", formValues);
  // console.log("formErrors=> ", formErrors);

  return (
    <>
      <CommonHeadingNBtns
        title={`${isEdit ? "Edit" : "Add"} Task Frequency`}
        onClose={closeModal}
        onClick={onSubmit}
        isLoading={postPutLoading}
      />

      <form className="formContainer">
        <div className="formInputsGrid twoGridSystem">
          <div className="formInputBox">
            <label
              htmlFor="selectedTaskFrequencyName"
              className={`formInputLabel `}
            >
              status name <span className="required">*</span>
            </label>

            <div
              className={`commonWrapper ${
                formErrors?.selectedTaskFrequencyName ? "formError" : ""
              }`}
            >
              <SelectDropdownLabel
                options={hygine_task_frequency_categories}
                selectedOption={formValues.selectedTaskFrequencyName}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown(selectedValue, "selectedTaskFrequencyName")
                }
                name="Select"
                preventKeyboardOpen={true}
              />
            </div>
          </div>

          <div className="formInputBox selected-multi-box equal-inputs">
            <label htmlFor="startTime" className="formInputLabel">
              Start and End time{" "}
              {formValues.selectedTaskFrequencyName?.value ===
                "daily_onetime" && <span className="required">*</span>}
            </label>

            <div className="flex-box">
              <div className={`enter-value commonWrapper`}>
                <input
                  type="time"
                  placeholder="Duration"
                  className={`formInput ${
                    formErrors?.startTime ? "formError" : ""
                  }`}
                  name="startTime"
                  value={formValues.startTime}
                  onChange={onChangeInput}
                />
              </div>

              <div className={`enter-value commonWrapper`}>
                <input
                  type="time"
                  placeholder="Duration"
                  className={`formInput ${
                    formErrors?.endTime ? "formError" : ""
                  }`}
                  name="endTime"
                  value={formValues.endTime}
                  onChange={onChangeInput}
                />
              </div>
            </div>
          </div>

          {formValues.selectedTaskFrequencyName?.value === "daily_hourly" && (
            <div className="formInputBox">
              <label
                htmlFor="selectedFrequencyInterval"
                className={`formInputLabel `}
              >
                time interval <span className="required">*</span>
              </label>

              <div
                className={`commonWrapper ${
                  formErrors?.selectedFrequencyInterval ? "formError" : ""
                }`}
              >
                <SelectDropdownLabel
                  options={generateNumberObjects()}
                  selectedOption={formValues.selectedFrequencyInterval}
                  setSelectedOption={(selectedValue) =>
                    onChangeDropdown(selectedValue, "selectedFrequencyInterval")
                  }
                  name="Select"
                />
              </div>
            </div>
          )}

          {formValues.selectedTaskFrequencyName?.value === "yearly" && (
            <div className="formInputBox">
              <label htmlFor="selectedMonth" className={`formInputLabel `}>
                month <span className="required">*</span>
              </label>

              <div
                className={`commonWrapper ${
                  formErrors?.selectedMonth ? "formError" : ""
                }`}
              >
                <SelectDropdownLabel
                  options={months}
                  selectedOption={formValues.selectedMonth}
                  setSelectedOption={(selectedValue) =>
                    onChangeDropdown(selectedValue, "selectedMonth")
                  }
                  name="Select"
                />
              </div>
            </div>
          )}

          {(formValues.selectedTaskFrequencyName?.value === "monthly" ||
            formValues.selectedTaskFrequencyName?.value === "yearly") && (
            <div className="formInputBox">
              <label htmlFor="frequencyDate" className={`formInputLabel `}>
                date <span className="required">*</span>
              </label>

              <input
                type="date"
                placeholder="Date"
                className={`formInput ${
                  formErrors?.frequencyDate ? "formError" : ""
                } ${formValues.frequencyDate ? "date-has-value" : ""}`}
                name="frequencyDate"
                value={formValues.frequencyDate}
                onChange={onChangeInput}
                min={currentDateOfTheMonth}
              />
            </div>
          )}

          {formValues.selectedTaskFrequencyName?.value === "weekly" && (
            <div className="formInputBox checkbox-wrapper span2">
              <label htmlFor="frequencyDays" className="formInputLabel">
                choose days <span className="required">*</span>
              </label>

              <div
                className={`flex-box ${
                  formErrors?.frequencyDays ? "formError" : ""
                }`}
                style={{
                  padding: formErrors?.frequencyDays ? "15px" : "",
                  borderRadius: "10px",
                }}
              >
                {daysOfWeek.map((day) => (
                  <label key={day.value} className="checkboxLabel">
                    <input
                      type="checkbox"
                      value={day.value}
                      checked={formValues.frequencyDays.includes(day.value)}
                      onChange={() => handleCheckboxChange(day.value)}
                    />
                    {day.label}
                  </label>
                ))}
              </div>
            </div>
          )}
        </div>

        <div className="formInputsGrid switchInputs">
          <div
            className={`commonWrapper commonSwitchWrapper no-border ${
              formErrors?.isActive ? "formError" : ""
            }`}
          >
            <Form.Check
              type="switch"
              name="isActive"
              label={`Active`}
              className={`hygine-label ${formValues.isActive ? "active" : ""}`}
              checked={formValues.isActive}
              onChange={onChangeInput}
            />
          </div>
        </div>
      </form>
    </>
  );
};

export default TaskFrequencyForm;
